import isTextStylesAllowed from 'editor/src/store/editor/selector/isTextStylesAllowed';

import { CanShow } from 'editor/src/component/Menu/type';

import TextStyleModifiedItem from './TextStyleModifiedItem';

/** GAPI-61895: opt-in per host (and in the embedded editor per template), never on locked texts. */
export const canShow: CanShow = (state, { isPersonalizationLocked }) =>
  !isPersonalizationLocked && isTextStylesAllowed(state);

export default TextStyleModifiedItem;
